import { useDispatch, useSelector } from 'react-redux';
import ToggleSwitch from 'lib/ToggleSwitch';
import { Label } from 'lib/Label';
import { DirectSalesExclusionFlag } from 'components/common/types/DirectSalesDeal.types';
import { Store } from 'components/common/types/Store.types';
import { changeDealData } from 'store/dealManagement/reducer';

const BlockedExclusion: React.FC = () => {
  const dispatch = useDispatch();

  const advertiserBlockExclusion = useSelector(
    (state: Store) => state.dealManagement.commonDeal.advertiserBlockExclusion,
  );
  const agencyBlockExclusion = useSelector((state: Store) => state.dealManagement.commonDeal.agencyBlockExclusion);
  const specialistBlockExclusion = useSelector(
    (state: Store) => state.dealManagement.commonDeal.specialistBlockExclusion,
  );

  const isAdvertiserBlocklistEnabled = advertiserBlockExclusion === DirectSalesExclusionFlag.ON;
  const isAgencyBlocklistEnabled = agencyBlockExclusion === DirectSalesExclusionFlag.ON;
  const isSpecialistBlocklistEnabled = specialistBlockExclusion === DirectSalesExclusionFlag.ON;

  return (
    <div className="flex flex-col gap-1.5 py-1.5">
      <div className="flex justify-between items-center">
        <Label id="advertiser-blocklist-label" label="Advertiser blocklist" className="mb-0" />
        <ToggleSwitch
          isChecked={isAdvertiserBlocklistEnabled}
          onChange={(isEnabled: boolean) =>
            dispatch(
              changeDealData({
                advertiserBlockExclusion: isEnabled ? DirectSalesExclusionFlag.ON : DirectSalesExclusionFlag.OFF,
              }),
            )
          }
          dataTestId="advertiser-blocklist-switch"
          id="advertiser-blocklist"
        />
      </div>
      <div className="flex justify-between items-center">
        <Label id="agency-blocklist-label" label="Agency blocklist" className="mb-0" />
        <ToggleSwitch
          isChecked={isAgencyBlocklistEnabled}
          onChange={(isEnabled: boolean) =>
            dispatch(
              changeDealData({
                agencyBlockExclusion: isEnabled ? DirectSalesExclusionFlag.ON : DirectSalesExclusionFlag.OFF,
              }),
            )
          }
          dataTestId="agency-blocklist-switch"
          id="agency-blocklist"
        />
      </div>
      <div className="flex justify-between items-center">
        <Label id="specialist-blocklist-label" label="Specialist blocklist" className="mb-0" />
        <ToggleSwitch
          isChecked={isSpecialistBlocklistEnabled}
          onChange={(isEnabled: boolean) =>
            dispatch(
              changeDealData({
                specialistBlockExclusion: isEnabled ? DirectSalesExclusionFlag.ON : DirectSalesExclusionFlag.OFF,
              }),
            )
          }
          dataTestId="specialist-blocklist-switch"
          id="specialist-blocklist"
        />
      </div>
    </div>
  );
};

export default BlockedExclusion;
